import { Store } from "vuex";
import { ApiStatus } from "@/store/general.types";
import { AccountState, ParticipantAuthorityPayload } from "./account.types";
import { accountApi } from "@/api/account.api";

export const accountActions = {
    async getAccount(store: Store<AccountState>) {
        try {
            store.commit('GET_ACCOUNT_MUTATION', ApiStatus.LOADING);

            const { data } = await accountApi.getAccount();

            // Ensure we have valid account data
            if (!data || !data.id) {
                throw new Error('Invalid account data received');
            }

            store.commit('GET_ACCOUNT_MUTATION', { data });

            // Populate BCM backend session cache to prevent 419 errors
            try {
                await accountApi.pushAccountToBcm(data);
            } catch (e) {
                console.warn('Failed to push account to BCM session cache:', e);
            }

            return data; // Return the data for the caller
        } catch (error) {
            store.commit('GET_ACCOUNT_MUTATION', { error });
            // Re-throw the error so the calling component can handle it
            throw error;
        }
    },
    async getParticipantAuthority(store: Store<AccountState>, participantAuthorityPayload: ParticipantAuthorityPayload) {
        try {
            store.commit('GET_PARTICIPANT_AUTHORITY', ApiStatus.LOADING);
            const { data } = await accountApi.getParticipantAuthority(participantAuthorityPayload);
            store.commit('GET_PARTICIPANT_AUTHORITY', { data });
        } catch (error) {
            store.commit('GET_PARTICIPANT_AUTHORITY', { error })
        }
    }
}